import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=b206ef60&scoped=true&"
import script from "./Preview.vue?vue&type=script&lang=js&"
export * from "./Preview.vue?vue&type=script&lang=js&"
import style0 from "./Preview.vue?vue&type=style&index=0&id=b206ef60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b206ef60",
  null
  
)

export default component.exports